// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar_container{
    background-color: #012101;
    color: #FFFFFF;
    padding: 20px 50px 10px 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: 9999;
}

.flag_container{
    margin-left: 25rem;
}

.hambuger_icon img{
    width: 30px;
    height: 30px;
    display: none;
}

.navlink_container{
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
}

.navlink_container a{
    color: #FFFFFF;
    text-decoration: none;
    font-weight: 400;
    font-size: 16px;
    line-height: 24.46px;
}

.navbar_mobile_container{
    display: none;
}

.showNavDropdown{
    display: none;
}


/* responsiveness starts here */

@media screen and (max-width: 1050px){
    .flag_container{
        margin-left: 15rem;
    }
}

@media screen and (max-width: 900px){

    .navbar_container{
        padding: 15px 40px 8px 40px;
    }

    .flag_container{
        margin-left: 0;
    }

    .navlink_container{
        gap: 15px;
    }

    .navlink_container a{
        font-size: 14px;
    }


}


@media screen and (max-width: 500px){
    .navlink_container{
        display: none;
    }

    .hambuger_icon img{
        display: flex;
    }

    .logo_container img{
        width: 83px;
    }

    .flag_container img{
        width: 47px;
    }

    .navbar_container{
        padding: 15px 30px 8px 20px;
    }

    .navbar_mobile_container{
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        gap: 30px;
        height: 100vh ;
        width: 100vw;
        background-color: #FFFFFF;
        color: #0F0F0F;
        padding:  70px 50px 50px 50px;
        position: fixed;
        left: 0;
        z-index: 9997;
    }

    .navbar_mobile_container a{
        text-decoration: none;
        color: #0F0F0F;
    }

    .showNavDropdown{
        display: none;
    }

    .navbar_mobile_container a{
        font-size: 18px;
        font-weight: 400;
        line-height: 24px;
        text-decoration: none;
    }

    .navbar_mobile_container a:active,.navbar_mobile_container a.active{
        font-weight: 800;  
        color: #0F0F0F;  
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/Navbar.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,cAAc;IACd,4BAA4B;IAC5B,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,MAAM;IACN,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;;AAGA,+BAA+B;;AAE/B;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;;IAEI;QACI,2BAA2B;IAC/B;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;;AAGJ;;;AAGA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,2BAA2B;QAC3B,SAAS;QACT,cAAc;QACd,YAAY;QACZ,yBAAyB;QACzB,cAAc;QACd,6BAA6B;QAC7B,eAAe;QACf,OAAO;QACP,aAAa;IACjB;;IAEA;QACI,qBAAqB;QACrB,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,qBAAqB;IACzB;;IAEA;QACI,gBAAgB;QAChB,cAAc;IAClB;AACJ","sourcesContent":[".navbar_container{\n    background-color: #012101;\n    color: #FFFFFF;\n    padding: 20px 50px 10px 50px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    cursor: pointer;\n    position: fixed;\n    top: 0;\n    width: 100vw;\n    z-index: 9999;\n}\n\n.flag_container{\n    margin-left: 25rem;\n}\n\n.hambuger_icon img{\n    width: 30px;\n    height: 30px;\n    display: none;\n}\n\n.navlink_container{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 20px;\n}\n\n.navlink_container a{\n    color: #FFFFFF;\n    text-decoration: none;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24.46px;\n}\n\n.navbar_mobile_container{\n    display: none;\n}\n\n.showNavDropdown{\n    display: none;\n}\n\n\n/* responsiveness starts here */\n\n@media screen and (max-width: 1050px){\n    .flag_container{\n        margin-left: 15rem;\n    }\n}\n\n@media screen and (max-width: 900px){\n\n    .navbar_container{\n        padding: 15px 40px 8px 40px;\n    }\n\n    .flag_container{\n        margin-left: 0;\n    }\n\n    .navlink_container{\n        gap: 15px;\n    }\n\n    .navlink_container a{\n        font-size: 14px;\n    }\n\n\n}\n\n\n@media screen and (max-width: 500px){\n    .navlink_container{\n        display: none;\n    }\n\n    .hambuger_icon img{\n        display: flex;\n    }\n\n    .logo_container img{\n        width: 83px;\n    }\n\n    .flag_container img{\n        width: 47px;\n    }\n\n    .navbar_container{\n        padding: 15px 30px 8px 20px;\n    }\n\n    .navbar_mobile_container{\n        display: flex;\n        flex-direction: column;\n        justify-content: flex-start;\n        gap: 30px;\n        height: 100vh ;\n        width: 100vw;\n        background-color: #FFFFFF;\n        color: #0F0F0F;\n        padding:  70px 50px 50px 50px;\n        position: fixed;\n        left: 0;\n        z-index: 9997;\n    }\n\n    .navbar_mobile_container a{\n        text-decoration: none;\n        color: #0F0F0F;\n    }\n\n    .showNavDropdown{\n        display: none;\n    }\n\n    .navbar_mobile_container a{\n        font-size: 18px;\n        font-weight: 400;\n        line-height: 24px;\n        text-decoration: none;\n    }\n\n    .navbar_mobile_container a:active,.navbar_mobile_container a.active{\n        font-weight: 800;  \n        color: #0F0F0F;  \n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
